// gardes
import gql from 'graphql-tag'

export const ALL_GARDES = gql`
query allListes{
  allListes(orderBy: ID_DESC){
    edges { 
      node{
        id
        date   
      }
    }
  }
}`

export const GARDE_BY_ID_QUERY = gql`
query ($id: Int!){
  listeById(id: $id){
    id
    date
    joursByListeId(orderBy: DATE_ASC){
      edges{
        node{
          id
          date
          titulaireByTitulaireId{
            id
            nom
            prenom
            adeli
          }
        }
      }
    }
  }
}
`

export const JOUR_BY_ID = gql`
 query jourById($id: Int!){
  jourById(id:$id)
  {
    id
    date
    titulaireId
    titulaireByTitulaireId{
      nom
      prenom
    }
  }
} `

export const JOUR_BY_LISTID = gql`
query allJours($id: Int!){
  allJours(condition: {
    listeId: $id
  },orderBy: DATE_ASC  ){
    edges{
    node{
      listeId
      id
      date
      titulaireByTitulaireId {
        id
        nom
        prenom
        }
      }
    }
  }
}`

export const UPDATE_JOUR = gql`
mutation($id: Int!, $titulaireId: Int) {
  updateJourById(input: {id: $id, jourPatch: {titulaireId: $titulaireId}}) {
    jour {
      nodeId
      date
      titulaireId
      id
      listeId
    }
  }
}`

export const CREATE_LISTE = gql`
mutation($date: Date! ) {
  createListe(input:{
    liste:{
      date: $date
    }
  }){
    liste{
      id
      date
      nodeId
    }
  }
}
`

export const CREATE_JOUR = gql`
mutation ($date: Date!, $listeId: Int!){
  createJour(input:{
    jour:{
      date: $date
      listeId: $listeId   
    }
  }){
    jour{
      nodeId
      id
      listeId
    }
  }
}`

export const DELETE_LISTE = gql`
mutation ($id: Int!){
  deleteListeById(
    input: {
      id: $id
    }) {
  deletedListeId
  }
}`



// WEBPACK FOOTER //
// ./src/constants/gardes.js